module.exports = "label span{\r\n    display: inline-block;\r\n    margin-left:10px;\r\n    color:#444;\r\n}\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.applicationview label{\r\n    color:#000;\r\n}\r\n\r\n.field-title{\r\n    width:250px;\r\n    display:inline-block;\r\n    color:#807f7f;\r\n}\r\n\r\ntd{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/appstatus/appstatus.component.css
// module id = ./src/app/applicant/appstatus/appstatus.component.css
// module chunks = main